import CartConfirmationPage from './CartConfirmationPage'

export default CartConfirmationPage
// eslint-disable-next-line import/export
export * from './CartConfirmationPage'
